<template>
    <el-dialog @close='closeDialog' title="订单详情" :visible.sync="dialogVisible">
        <div class="order_detail_warp">
            <div class="user_info_div flex_center">
                <!-- <img :src="require('@/common/images/communityPurchases/logo.png')" alt=""> -->
                <img :src="orderDetailsInfo.customericonurl" alt="">
                <span>{{orderDetailsInfo.customername}}</span>
            </div>
            <p class="activity_name_text">
                <span class="color_gray">活动名称：</span>
                <span>{{orderDetailsInfo.eventname}}</span>
            </p>
            <div>
                <p class="title_text">订单信息</p>
                <div class="order_detail_info_div">
                    <div class="flex_center">
                        <p><span class="color_gray">订单号：</span>{{orderDetailsInfo.orderno}}</p>
                        <p :class="orderStatusClass(orderDetailsInfo.statusname)"><span class="color_gray">订单状态：</span>{{orderDetailsInfo.statusname}}</p>
                    </div>
                    <div class="flex_center">
                        <p><span class="color_gray">订单金额：</span>¥{{orderDetailsInfo.ordermoney}}</p>
                        <p><span class="color_gray">订单时间：</span> {{orderDetailsInfo.ordertime}}</p>
                    </div>
                </div>
            </div>
            <div v-if="orderDetailsInfo.resulttype === '3'">
                <p class="title_text">兑换信息</p>
                <div class="order_detail_info_div">
                    <div class="flex_center">
                        <p><span class="color_gray">兑换码：</span>{{orderDetailsInfo.code}}</p>
                    </div>
                </div>
            </div>
            <div v-if="orderDetailsInfo.resulttype === '5'">
                <p class="title_text">配送信息</p>
                <div class="order_detail_info_div">
                    <div class="flex_center">
                        <p><span class="color_gray">配送人：</span>{{orderDetailsInfo.shipname}}</p>
                        <p><span class="color_gray">配送电话：</span>{{orderDetailsInfo.shiptel}}</p>
                    </div>
                    <div class="flex_center">
                        <p><span class="color_gray">配送地址：</span>{{orderDetailsInfo.shipaddress}}</p>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'OrderDetailPop',
    props: ['orderDetailsInfo'],
    data() {
        return {
            dialogVisible: false
        }
    },
    mounted() {},
    methods: {
        // 打开弹窗
        openDialog() {
            this.dialogVisible = true
        },
        // 关闭弹框
        closeDialog() {
            this.dialogVisible = false
        },
        orderStatusClass(val) {
            if (val === '已取消') {
                return 'gray_text'
            } else if (val === '已完成') {
                return 'green_text'
            } else if (val === '待核销' || val === '待支付') {
                return 'yellow_text'
            }
        }
    },
    filters: {},
    watch: {
        orderDetailsInfo(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                // console.log('this.orderDetailsInfo:', this.orderDetailsInfo)
            })
        }
    },
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .order_detail_warp {
        color: #303133;
        .flex_center {
            display: flex;
            align-items: center;
        }
        .color_gray {
            color: #606266;
        }
        .user_info_div {
            img{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-right: 10px;
            }
        }
        .activity_name_text {
            display: flex;
            margin: 30px 0;
            span:nth-of-type(1){
                white-space: nowrap;
                line-height: 18px;
            }
            span:nth-of-type(2){
                line-height: 18px;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
            }
        }
        .title_text {
            margin: 30px 0 20px 0;
            padding-left: 10px;
            font-weight: bold;
            border-left: 2px solid #409EFF;
        }
        .order_detail_info_div {
            .green_text {
                color: #67C23A;
            }
            .yellow_text {
                color: #E6A23C;
            }
            .gray_text {
                color: #909399;
            }
            &>div {
                p:nth-of-type(1) {
                    width: 400px;
                    line-height: 18px;
                }
            }
            &>div:nth-of-type(2) {
                margin-top: 10px;
            }
        }
    }
</style>